module.exports = __webpack_public_path__ + "assets/img/danyao-84f54a44.png";